import { Routes } from '@angular/router';
import { YesNoAudioPage } from './yes-no-audio-page/yes-no-audio-page';
import { YesNoMixedPage } from './yes-no-mixed-page/yes-no-mixed-page';
import { YesNoPage } from './yes-no-page';
import { YesNoSentencePage } from './yes-no-sentence-page/yes-no-sentence-page';
import { YesNoWordPage } from './yes-no-word-page/yes-no-word-page';
import { YesNoWordsPage } from './yes-no-words-page/yes-no-words-page';

export const mechanicYesOrNoRoutes: Routes = [
  {
    path: '',
    component: YesNoPage,
  },
  {
    path: 'mixed',
    component: YesNoMixedPage,
  },
  {
    path: 'double-word',
    component: YesNoWordsPage,
  },
  {
    path: 'audio',
    component: YesNoAudioPage,
  },
  {
    path: 'word',
    component: YesNoWordPage,
  },
  {
    path: 'sentence',
    component: YesNoSentencePage,
  },
];
